module.exports = __webpack_public_path__ + "img/sbm1.bfedd2a1.jpg";